import React from 'react';
import ApplicationError from "./ApplicationError";
import Analytics from "./classes/Analytics";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { IAppState } from "./state/interfaces";
import { NO_QUOTE_LABEL } from "./AppConstants";
import EventApiClient from "./classes/EventApiClient";

interface IProps extends RouteComponentProps {
    quoteId: number | null,
    children: any,
    stateCode: string | null;
}

interface IState {
    childError?: boolean;
}

interface IError {
    fileName? : string,
    message : string,
    stack?: string;
}

class ApplicationErrorBoundary extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            childError: false
        };
    }

    componentDidCatch(error: IError, errorInfo: React.ErrorInfo) {
        const errorLabel = this.props.quoteId?.toString() ?? NO_QUOTE_LABEL;

        //Analytics.onScriptError(
        //    errorLabel,
        //    this.props.location.pathname,
        //    error?.fileName ?? "",
        //    error.message,
        //    error?.stack ?? ""
        //);

        const api = new EventApiClient();
        api.registerScriptError(error?.fileName ?? "", error.message, error?.stack ?? "", errorLabel);
    }

    static getDerivedStateFromError(error: Error) {          
        return { childError: true }
    }

    componentDidMount() {
        
    }

    render() {
        return (
            <div>
                {this.state.childError ? <ApplicationError /> : this.props.children}
            </div>
        );
    }
}

let mapProps = (state: IAppState, ownProps: any) => {
    //console.log("state.quoteId=" + state.quoteId);
    //console.log(ownProps.location.pathname);
    return {
        quoteId: state.quoteId,
        stateCode: state.stateCode
    };
};

//export default ApplicationErrorBoundary;
export default withRouter(connect(mapProps, null)(ApplicationErrorBoundary));

